enum UrlParams {
  PROVIDER = `provider`,
  ACCESS_TOKEN = `access_token`,
}

export default UrlParams
